
import { CapexReportDescription, emptyPPTReport, FormEditMode, ReportDisplay, ReportType } from "../../helpers/constants";
import React, { useCallback, useEffect } from "react";
import { PPTReport, PPTRulesCategorisation, PPTRulesDescription, PPTRulesResponse } from "../../helpers/interfaces";
import { getAllPPTRulesCategorisation, getAllPPTRulesDescription } from "../../apiServices/PPTRulesApi";
import { Button, Table, TableBody, TableContainer, TableHead, useTheme } from "@mui/material";
import { CustomTextField, StyledTableCell, StyledTableRow } from "../../layouts/themes";
import { NumericFormat } from "react-number-format";
import { exportPPTReport, GeneratePPTReports, getAllPPTReports, getGeneratedPPTReports } from "../../apiServices/PPTReportsApi";
import saveAs from "file-saver";
import { useMemo } from 'react';

interface Props {
    pptReportsEditMode: number
    pptReports: PPTReport[]
    setPPTReports: React.Dispatch<React.SetStateAction<PPTReport[]>>
    pptRulesResponse:  PPTRulesResponse
    reportDisplay: ReportDisplay
    setReportDisplay: React.Dispatch<React.SetStateAction<ReportDisplay>>
    reportType: ReportType
    year: number
    pptReportsToEdit: string
    setPPTReportsEditMode: React.Dispatch<React.SetStateAction<number>>
}


function CapexReportView(props: Props) {

    const [report, setReport] = React.useState<PPTReport>(emptyPPTReport)

    const [ADDITIONSPERAUDITEDFINANCIALSTATEMENTID, setADDITIONSPERAUDITEDFINANCIALSTATEMENTID] = React.useState<string>('');
    const [ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID, setADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID] = React.useState<string>('');

    const [INTANGIBLEEXPLODEVELOPMENTCOSTID, setINTANGIBLEEXPLODEVELOPMENTCOSTID] = React.useState<string>('');

    const [OTHERINTANGIBLEASSETSID, setOTHERINTANGIBLEASSETSID] = React.useState<string>('');

    const [TANGIBLECOSTID, setTANGIBLECOSTID] = React.useState<string>('');
    const [pptReportsRequest, SetPptReportsRequest] = React.useState<any>();
    const [pptDescriptions, setPPTDescriptions] = React.useState<PPTRulesDescription[]>([])
    const [pptCategorizations, setPPTCategorizations] = React.useState<PPTRulesCategorisation[]>([])

    // const [disallowedCostTotal, SetDisallowedCostTotal] = React.useState<any>();
    const theme = useTheme();



    const GetGeneratedPPTReports = async () => {
        const report = await getGeneratedPPTReports(props.pptReportsToEdit)
        let _report = {
            title: report.title,
            subject: report.subject,
            reportType: report.reportType,
            pptReportsDescriptionRequests: report.pptReportsDescription.map(a => {
                return {
                    pptRulesDescriptionId: a.pptRulesDescriptionId,
                    pptReportsDescriptionCategorisationRequests: a.pptReportsDescriptionCategorisations.map(b => {
                        return {
                            pptRulesCategorisationId: b.pptRulesCategorisationId,
                            amount: b.amount,
                            isManualInput: false
                        }
                    })
                }
            }),
            pptReportsFooterRequests: report.pptReportsFooter.map(a => {
                return {
                    pptRulesDescriptionId: a.pptRulesDescriptionId,
                    amount: a.amount,

                }
            })
        }
        SetPptReportsRequest(_report)
    }
    useEffect(() => {
        if (props.pptReportsEditMode === FormEditMode.EDIT) {
            GetGeneratedPPTReports()

            // getPPTRulesDescription()
            console.log(pptReportsRequest)
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.pptReportsEditMode, props.pptReportsToEdit])
    useEffect(() => {

        getAllPPTRulesCategorisation(props.reportType, String(props.year)).then(category => setPPTCategorizations(category.sort((a, b) => a.order - b.order)))
        getPPTRulesDescription()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.reportType])

    const getPPTRulesDescription = async () => {
        const desc = await getAllPPTRulesDescription(props.reportType
            , String(props.year)
        )

        const _ADDITIONSPERAUDITEDFINANCIALSTATEMENT = desc?.find(e => e.name === CapexReportDescription.ADDITIONSPERAUDITEDFINANCIALSTATEMENT)?.id
        const _ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID = desc?.find(e => e.name === CapexReportDescription.ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENT)?.id
        const _INTANGIBLEEXPLODEVELOPMENTCOSTID = desc?.find(e => e.name === CapexReportDescription.INTANGIBLEEXPLODEVELOPMENTCOST)?.id
        const _OTHERINTANGIBLEASSETSID = desc?.find(e => e.name === CapexReportDescription.OTHERINTANGIBLEASSETS)?.id
        const _TANGIBLECOST = desc?.find(e => e.name === CapexReportDescription.TANGIBLECOST)?.id

        setADDITIONSPERAUDITEDFINANCIALSTATEMENTID(_ADDITIONSPERAUDITEDFINANCIALSTATEMENT ?? '')
        setADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID(_ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID ?? '')
        setINTANGIBLEEXPLODEVELOPMENTCOSTID(_INTANGIBLEEXPLODEVELOPMENTCOSTID ?? '')
        setOTHERINTANGIBLEASSETSID(_OTHERINTANGIBLEASSETSID ?? '')
        setTANGIBLECOSTID(_TANGIBLECOST ?? '')
        setPPTDescriptions(desc.sort((a, b) => a.order - b.order))

        if (props.pptReportsEditMode !== FormEditMode.EDIT) {
            let request = {
                title: report.title,
                subject: report.subject,
                 year: String(props.year),
                reportType: props.reportType,
                pptReportsDescriptionRequests: [
                    {
                        pptRulesDescriptionId: _ADDITIONSPERAUDITEDFINANCIALSTATEMENT,
                        pptReportsDescriptionCategorisationRequests: []
                    },

                    {
                        pptRulesDescriptionId: _ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID,
                        pptReportsDescriptionCategorisationRequests: []
                    },

                    ...props.pptRulesResponse?.pptReports.map(a => {
                        return {
                            pptRulesDescriptionId: a.pptRulesDescriptionId,
                            pptReportsDescriptionCategorisationRequests: a.pptRulesDescriptionCategorisations.map(b => {
                                return {
                                    pptRulesCategorisationId: b.pptRulesCategorisationId,
                                    amount: b.amount,
                                    isManualInput: b.isManualInput
                                }
                            })
                        }
                    })
                ],
                pptReportsFooterRequests: [
                    {
                        pptRulesDescriptionId: _INTANGIBLEEXPLODEVELOPMENTCOSTID,
                        amount: 0
                    },

                    {
                        pptRulesDescriptionId: _TANGIBLECOST,
                        amount: 0
                    },


                    {
                        pptRulesDescriptionId: _OTHERINTANGIBLEASSETSID,
                        amount: 0
                    },

                    ...report.pptReportsFooter.map(a => {
                        return {
                            pptRulesDescriptionId: a.pptRulesDescriptionId,
                            amount: a.amount

                        }
                    })
                ]
            }

            SetPptReportsRequest(request)
        }

    }
   

    const handleUpdateFieldValue = (pptRulesDescriptionId: string, pptRulesCategorisationId: string, amount: string) => {
        let _pptReportsRequest;

        let _pptRulesDescription = pptReportsRequest?.pptReportsDescriptionRequests?.find((a: any) => a.pptRulesDescriptionId === pptRulesDescriptionId);
        if (_pptRulesDescription == null || _pptRulesDescription === undefined) {
            let _newpptRulesDescription = {
                pptRulesDescriptionId: pptRulesDescriptionId,
                pptReportsDescriptionCategorisationRequests: [{
                    pptRulesCategorisationId: pptRulesCategorisationId,
                    amount: Number.parseInt(amount),
                }]
            }
            _pptReportsRequest = { ...pptReportsRequest, pptReportsDescriptionRequests: [...pptReportsRequest.pptReportsDescriptionRequests, _newpptRulesDescription] }
        }
        else {
            _pptReportsRequest = {
                ...pptReportsRequest, pptReportsDescriptionRequests: pptReportsRequest.pptReportsDescriptionRequests.map((a: any) => {
                    if (a.pptRulesDescriptionId === pptRulesDescriptionId) {

                        let _pptRulesCategorisation = _pptRulesDescription?.pptReportsDescriptionCategorisationRequests?.find((f: any) => f.pptRulesCategorisationId === pptRulesCategorisationId)

                        if (_pptRulesCategorisation === null || _pptRulesCategorisation === undefined) {
                            a.pptReportsDescriptionCategorisationRequests.push({
                                pptRulesCategorisationId: pptRulesCategorisationId,
                                amount: Number.parseInt(amount),
                            })
                            setReport(report)
                            return a;


                        } else {

                            return { ...a, pptReportsDescriptionCategorisationRequests: a.pptReportsDescriptionCategorisationRequests.map((b: any) => b.pptRulesCategorisationId === pptRulesCategorisationId ? { ...b, amount: Number.parseInt(amount) } : b) }
                        }
                    } else { return a; }

                })
            }
        }
        setReport(_pptReportsRequest)
        SetPptReportsRequest(_pptReportsRequest)
    };
    const handleUpdateFooterFieldValue = (pptRulesDescriptionId: string, amount: string) => {
        console.log(pptRulesDescriptionId)
        let _pptReportsRequest;

        let _pptRulesDescription = pptReportsRequest?.pptReportsFooterRequests?.find((a: any) => a.pptRulesDescriptionId === pptRulesDescriptionId);
        if (_pptRulesDescription == null || _pptRulesDescription === undefined) {
            let _newpptRulesDescription = {
                pptRulesDescriptionId: pptRulesDescriptionId,
                amount: Number.parseInt(amount),
            }
            _pptReportsRequest = { ...pptReportsRequest, pptReportsFooterRequests: [...pptReportsRequest.pptReportsFooterRequests, _newpptRulesDescription] }
        }
        else {
            _pptReportsRequest = {
                ...pptReportsRequest, pptReportsFooterRequests: pptReportsRequest.pptReportsFooterRequests.map((a: any) => {
                    if (a.pptRulesDescriptionId === pptRulesDescriptionId) {
                        return { ...a, amount: Number.parseInt(amount) }
                    }
                    else { return a; }
                })
            }
        }
        setReport(_pptReportsRequest)
        SetPptReportsRequest(_pptReportsRequest)
    };
    const getPPTRulesCategorisation = useCallback((pptRulesDescriptionId: string, pptRulesCategorisationId: string) => {
        console.log(pptReportsRequest)
        return pptReportsRequest?.pptReportsDescriptionRequests?.find((a: any) => a.pptRulesDescriptionId === pptRulesDescriptionId)?.pptReportsDescriptionCategorisationRequests?.find((f: any) => f.pptRulesCategorisationId === pptRulesCategorisationId)
    }, [pptReportsRequest]);


function submitReport() {
    // Remove invalid footer rows
    pptReportsRequest.pptReportsFooterRequests =
        pptReportsRequest.pptReportsFooterRequests.filter(
            (f: any) => f.pptRulesDescriptionId && f.pptRulesDescriptionId !== ""
        );
 
    pptReportsRequest.pptReportsDescriptionRequests =
        pptReportsRequest.pptReportsDescriptionRequests.filter(
            (r: any) => r.pptRulesDescriptionId && r.pptRulesDescriptionId !== ""
        );
 
    GeneratePPTReports(pptReportsRequest).then(() => {
        getAllPPTReports().then(reports => props.setPPTReports(reports));
    });
 
    props.setReportDisplay(ReportDisplay.TABLE);
}
    function base64ToBlob(base64string: string, type: string) {
        const binaryString = window.atob(base64string);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return new Blob([bytes], { type: type });
    }
    function exportReport() {
        console.log(props.pptReportsToEdit)
        exportPPTReport(props.pptReportsToEdit).then(async (base64string) => {
            const blob = base64ToBlob(base64string, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            saveAs(blob, `PPTR Report.xlsx`);
        })
    }

 const nearestThousand = (num: number) => Math.ceil(num / 1000)

    const disallowedCostTotal = useMemo(() => {
        const { total } = pptCategorizations.reduce<{
            total: number;
            cells: JSX.Element[];
        }>(
            (acc, f) => {
                let pptRulesTotal = props.pptRulesResponse.pptReports?.reduce((sum, v) => sum + (parseFloat(getPPTRulesCategorisation(v.pptRulesDescriptionId, f.id)?.amount) || 0), 0);

                acc.total += pptRulesTotal;
                acc.cells.push(
                    <StyledTableCell key={f.id} style={{ fontWeight: 'bold' }} >
                        {pptRulesTotal?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                    </StyledTableCell>
                );
                return acc;
            },
            { total: 0, cells: [] }
        );
        return total;
    }, [getPPTRulesCategorisation, pptCategorizations, props.pptRulesResponse.pptReports]);
    return (
        <div>
            {props.pptReportsEditMode !== FormEditMode.EDIT &&
                <div style={{ float: 'right' }}>
                    <Button color='secondary' variant="contained" onClick={() => submitReport()}>Submit Report</Button>
                </div>
            }
            {props.pptReportsEditMode === FormEditMode.EDIT &&
                <div style={{ float: 'right' }}>
                    <Button color='info' variant="contained" onClick={() => exportReport()}>Export Report To Excel</Button>
                </div>
            }
            <br />
            <div>
                <div className=' flex flex-row w-full '>
                    <div className=' w-2/4 ' >
                        <div >
                            <label className='title-label'>Title <span className='important'>*</span></label>
                        </div>
                        <div style={{ width: '100%' }} >
                            <div className="form-group mb-0" style={{ width: '100%' }}>
                                <div style={{ width: '100%' }}>
                                    <CustomTextField disabled={props.pptReportsEditMode === FormEditMode.EDIT} size="small" id="outlined-basic" placeholder="Title" value={pptReportsRequest?.title} onChange={(event) => { SetPptReportsRequest({ ...pptReportsRequest, title: event.target.value }) }} variant="outlined" sx={{ width: '100%' }} />

                                </div>
                            </div>
                        </div>

                    </div> &nbsp;&nbsp;&nbsp;

                    <div className='  w-2/4 '>
                        <div >
                            <label className='title-label'>Subject <span className='important'>*</span></label>
                        </div>
                        <div style={{ width: '100%' }} >
                            <div className="form-group mb-0" style={{ width: '100%' }} >
                                <div style={{ width: '100%' }} >
                                    <CustomTextField disabled={props.pptReportsEditMode === FormEditMode.EDIT} size="small" id="outlined-basic" placeholder="Subject" value={pptReportsRequest?.subject} onChange={(event) => { SetPptReportsRequest({ ...pptReportsRequest, subject: event.target.value }) }} variant="outlined" sx={{ width: '100%' }} />

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <br />

                <div className="">
                    <TableContainer className="table table-bordered table-sm table-responsive" sx={{ maxHeight: '56vh', overflowX: 'scroll', overflowY: 'auto', border: '1px solid rgba(224, 224, 224, 1)', '&::-webkit-scrollbar': { width: '6px', height: '6px', }, '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(0,0,0,0.1)', }, '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.3)', borderRadius: '4px', }, '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(0,0,0,0.5)', } }}    >
                        <Table size="small" aria-label="a dense table" aria-labelledby="tableTitle">
                            <TableHead>

                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`,  textTransform: 'capitalize', fontSize: '12px', minWidth: '250px', fontWeight: 'bold', position: "sticky", top: 0, zIndex: 1 }} ><b>Description</b></StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.name}
                                        style={{ background: `${theme.palette.error.contrastText}`,  textTransform: 'capitalize', fontSize: '12px', minWidth: '250px', fontWeight: 'bold', position: "sticky", top: 0, zIndex: 1 }}>
                                            {e.name}&nbsp;($)
                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell ><b>Total</b></StyledTableCell>
                                </StyledTableRow>

                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell
                                        style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}
                                    >
                                        ADDITIONS PER AUDITED FINANCIAL STATEMENT(AFS)
                                    </StyledTableCell>

                                    {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, e) => {
                                        const amount = getPPTRulesCategorisation(ADDITIONSPERAUDITEDFINANCIALSTATEMENTID, e.id)?.amount || 0;
                                        const numericAmount = parseFloat(amount) || 0;
                                        acc.total += numericAmount;

                                        acc.cells.push(
                                            <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                <NumericFormat

                                                    size="small"
                                                    disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                    customInput={CustomTextField}
                                                    id="outlined-basic"
                                                    name="amount"
                                                    placeholder="Amount"
                                                    variant="outlined"
                                                    value={amount}
                                                    style={{ width: '100%' }}

                                                    onChange={(event: { target: { value: string } }) =>
                                                        handleUpdateFieldValue(ADDITIONSPERAUDITEDFINANCIALSTATEMENTID, e.id, event.target.value)
                                                    }
                                                />

                                            </StyledTableCell>
                                        );

                                        return acc;
                                    }, { total: 0, cells: [] }).cells}

                                    <StyledTableCell style={{ fontWeight: 'bold' }}>

                                        {nearestThousand(pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(ADDITIONSPERAUDITEDFINANCIALSTATEMENTID, e.id)?.amount) || 0), 0))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>

                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>LESS</StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>

                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell>0</StyledTableCell>
                                </StyledTableRow>

                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}></StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>

                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell></StyledTableCell>
                                </StyledTableRow>


                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>ITEMS CAPITALISED IN AUDITED FINANCIAL STATEMENTS BUT NOT IN PPT RETURNS</StyledTableCell>


                                </StyledTableRow>
                                {props.pptReportsEditMode !== FormEditMode.EDIT ?
                                    <>
                                        {props.pptRulesResponse.pptReports?.map((e, index) => {
                                            let desc = pptDescriptions.find(d => d.id === e.pptRulesDescriptionId)!

                                            return <StyledTableRow key={index}>


                                                <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', minWidth: '350px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>
                                                    {desc?.name}

                                                </StyledTableCell>

                                                {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, f) => {
                                                    const categ = getPPTRulesCategorisation(e.pptRulesDescriptionId, f.id)
                                                    const amount = categ?.amount;
                                                    const numericAmount = parseFloat(amount) || 0;
                                                    acc.total += numericAmount;

                                                    acc.cells.push(
                                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                            {categ?.isManualInput ? <>
                                                                <NumericFormat
                                                                    disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                                    size="small"
                                                                    customInput={CustomTextField}
                                                                    id="outlined-basic"
                                                                    name="amount"
                                                                    placeholder="Amount"
                                                                    variant="outlined"
                                                                    value={amount}
                                                                    style={{ width: '100%' }}
                                                                    onChange={(event: { target: { value: string } }) => handleUpdateFieldValue(e.pptRulesDescriptionId, f.id, event.target.value)
                                                                    }
                                                                />
                                                            </> : <>
                                                                {amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                            </>}
                                                        </StyledTableCell>
                                                    );

                                                    return acc;
                                                }, { total: 0, cells: [] }).cells}

                                                <StyledTableCell style={{ fontWeight: 'bold' }}>
                                                    {pptCategorizations.reduce((sum, f) => sum + (parseFloat(getPPTRulesCategorisation(e.pptRulesDescriptionId, f.id)?.amount) || 0), 0)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                </StyledTableCell>
                                            </StyledTableRow>

                                        })}
                                    </> :
                                    <>
                                        {pptReportsRequest?.pptReportsDescriptionRequests?.map((e: { pptRulesDescriptionId: string; }, index: any) => {
                                            let desc = pptDescriptions.find(d => d.id === e.pptRulesDescriptionId)!
                                            return <StyledTableRow key={index}>


                                                <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', minWidth: '350px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>
                                                    {desc?.name}

                                                </StyledTableCell>

                                                {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, f) => {
                                                    const categ = getPPTRulesCategorisation(e.pptRulesDescriptionId, f.id)
                                                    const amount = categ?.amount;
                                                    const numericAmount = parseFloat(amount) || 0;
                                                    acc.total += numericAmount;

                                                    acc.cells.push(
                                                        <StyledTableCell key={e.pptRulesDescriptionId} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                            {categ?.isManualInput ? <>

                                                                <NumericFormat
                                                                    disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                                    size="small"
                                                                    customInput={CustomTextField}
                                                                    id="outlined-basic"
                                                                    name="amount"
                                                                    placeholder="Amount"
                                                                    variant="outlined"
                                                                    value={amount}
                                                                    style={{ width: '100%' }}
                                                                    onChange={(event: { target: { value: string } }) => handleUpdateFieldValue(e.pptRulesDescriptionId, f.id, event.target.value)
                                                                    }
                                                                />
                                                            </> : <>
                                                                {amount?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                            </>}
                                                        </StyledTableCell>
                                                    );

                                                    return acc;
                                                }, { total: 0, cells: [] }).cells}

                                                <StyledTableCell style={{ fontWeight: 'bold' }}>
                                                    {pptCategorizations.reduce((sum, f) => sum + (parseFloat(getPPTRulesCategorisation(e.pptRulesDescriptionId, f.id)?.amount) || 0), 0)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        })}
                                    </>
                                }
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}> ADD</StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>

                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell>0</StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>ADDITIONS INCLUDED IN PPT RETURNS BUT NOT IN AUDITED FINANCIAL STATEMENT</StyledTableCell>
                                    {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, e) => {
                                        const amount = getPPTRulesCategorisation(ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID, e.id)?.amount || 0;
                                        const numericAmount = parseFloat(amount) || 0;
                                        acc.total += numericAmount;

                                        acc.cells.push(
                                            <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                <NumericFormat
                                                    disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                    size="small"
                                                    customInput={CustomTextField}
                                                    id="outlined-basic"
                                                    name="amount"
                                                    placeholder="Amount"
                                                    variant="outlined"
                                                    value={amount}
                                                    style={{ width: '100%' }}
                                                    onChange={(event: { target: { value: string } }) =>
                                                        handleUpdateFieldValue(ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID, e.id, event.target.value)
                                                    }
                                                />
                                            </StyledTableCell>
                                        );

                                        return acc;
                                    }, { total: 0, cells: [] }).cells}

                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                        {pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID, e.id)?.amount) || 0), 0)}
                                    </StyledTableCell>
                                </StyledTableRow>

                                <StyledTableRow style={{ borderBottom: '2px solid #6c6c6cff', borderTop: '2px solid #6c6c6cff' }}>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}>CAPEX COSTS PER PPT RETURNS</StyledTableCell>
                                    {pptCategorizations.map(s => {
                                        return (
                                            <StyledTableCell key={s.id} style={{ fontWeight: 'bold' }}>

                                            </StyledTableCell>
                                        );
                                    })}
                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                        {(
                                            (disallowedCostTotal)
                                            +
                                            (pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID, e.id)?.amount) || 0), 0))
                                            +
                                            (pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(ADDITIONSPERAUDITEDFINANCIALSTATEMENTID, e.id)?.amount) || 0), 0))
                                        )?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}>The explanations provided should be sufficient to enable the auditors to verify</StyledTableCell>

                                </StyledTableRow>

                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>COST REPORTED IN THE PPT RETURNS</StyledTableCell>
                                    <StyledTableCell colSpan={pptCategorizations.length} ><b>SCHEDULE- {`${props.year}`}</b></StyledTableCell>
                                    <StyledTableCell ></StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}></StyledTableCell>
                                    <StyledTableCell colSpan={pptCategorizations.length - 1}><b>Intangible Explo & development cost</b></StyledTableCell>
                                    {pptReportsRequest?.pptReportsFooterRequests?.map((item: any) =>
                                        item.pptRulesDescriptionId === INTANGIBLEEXPLODEVELOPMENTCOSTID &&
                                        <StyledTableCell style={{ fontSize: '12px', width: '20%', fontWeight: '' }}>
                                            <NumericFormat

                                                disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                size="small"
                                                customInput={CustomTextField}
                                                id="outlined-basic"
                                                name="amount"
                                                placeholder="Amount"
                                                variant="outlined"
                                                value={item.amount}
                                                onChange={(event: { target: { value: string } }) =>
                                                    handleUpdateFooterFieldValue(INTANGIBLEEXPLODEVELOPMENTCOSTID, event.target.value)
                                                }
                                                style={{ width: '100%' }}

                                            />
                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell ></StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}></StyledTableCell>
                                    <StyledTableCell colSpan={pptCategorizations.length - 1}><b> Other Intangible Assets</b></StyledTableCell>
                                    {pptReportsRequest?.pptReportsFooterRequests?.map((item: any) =>
                                        item.pptRulesDescriptionId === OTHERINTANGIBLEASSETSID &&
                                        <StyledTableCell style={{ fontSize: '12px', width: '20%', fontWeight: '' }}>
                                            <NumericFormat
                                                disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                size="small"
                                                customInput={CustomTextField}
                                                id="outlined-basic"
                                                name="amount"
                                                placeholder="Amount"
                                                variant="outlined"
                                                value={item.amount}
                                                onChange={(event: { target: { value: string } }) =>
                                                    handleUpdateFooterFieldValue(OTHERINTANGIBLEASSETSID, event.target.value)
                                                }
                                                style={{ width: '100%' }}

                                            />
                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell ></StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}></StyledTableCell>
                                    <StyledTableCell colSpan={pptCategorizations.length - 1}><b>Tangible Cost (QCE)</b></StyledTableCell>
                                    {pptReportsRequest?.pptReportsFooterRequests?.map((item: any) =>
                                        item.pptRulesDescriptionId === TANGIBLECOSTID &&
                                        <StyledTableCell style={{ fontSize: '12px', fontWeight: '' }}>
                           
                                            {nearestThousand(Number(props.pptRulesResponse.pptReportsFooter.map(e=> e.amount))).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                          
                                        </StyledTableCell>
                                    )
                                    }

                                    <StyledTableCell ></StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}></StyledTableCell>
                                    <StyledTableCell colSpan={pptCategorizations.length}><b>Total</b></StyledTableCell>
                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                        {pptReportsRequest?.pptReportsFooterRequests?.reduce((sum: number, e: { amount: string; }) => sum + (parseFloat(e.amount) || 0), 0)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow style={{ borderBottom: '2px solid #6c6c6cff', borderTop: '2px solid #6c6c6cff' }}>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}>DIFFERENCE</StyledTableCell>
                                    <StyledTableCell colSpan={pptCategorizations.length}></StyledTableCell>
                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                        {((
                                            (disallowedCostTotal)
                                            +
                                            (pptCategorizations.reduce((sum, e) => sum + (Number(getPPTRulesCategorisation(ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENTID, e.id)?.amount) || 0), 0))
                                            +
                                            (pptCategorizations.reduce((sum, e) => sum + (Number(getPPTRulesCategorisation(ADDITIONSPERAUDITEDFINANCIALSTATEMENTID, e.id)?.amount) || 0), 0))
                                        )
                                            -
                                            (pptReportsRequest?.pptReportsFooterRequests?.reduce((sum: number, e: any) => sum + (Number(e.amount) || 0), 0)
                                            ))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}

                                    </StyledTableCell>
                                </StyledTableRow>

                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

        </div>
    )
}
export default CapexReportView